<div class="wrapper">
    <div class="section ">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 col-xs-12 d-flex align-self-baseline align-content-start flex-wrap">
                
                    <div class="card  shadow border-0 ">
                        <div class="card-body px-lg-5 py-lg-5">
                            <div class="text-center text-muted mb-4">
                                <h3>IMPUESTO PREDIAL - ESTADO DE CUENTA</h3>
                                <p class="text-dark mt-3 font-weight-bold">Fecha limite de Pago: 
                                    {{forma.fecha_limite |
                                    date:'dd-MM-yyyy'}}</p>
                                   
                                <div class="text-dark">
                                    <p class=" font-weight-bold">Clave Catastral: {{forma.ClaveCatastral}}</p>
                                    
                                    <p class=" font-weight-bold">Fecha Actual: {{fecha | date:'dd-MM-yyyy'}} </p>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p class="font-weight-bolder">PERIODO <span
                                            class="pull-right">{{forma.BimestreInicial}}</span></p>
                                   <p class="font-weight-bolder">IMPORTE A PAGAR <span class="pull-right">
                                            {{forma.ImporteTotal | currency}}</span></p>
                                         
                                </div>

                            </div>
                            <!-- (click)="enviar(m)"
                                *ngIf="forma.ImporteTotal!='0'"
                            -->
                            <div class="text-center">
                                <hr class="w-100 mb-3 mt-3">
                                <button  class="btn btn-primary mb-3" type="button"
                                    data-target="#modal-notification"
                                    
                                     (click)="enviar(m)"
                                     >
                                     
                                    PAGO EN LINEA
                                </button>
                                
                                <p class="mb-0">Este documento es de carácter informativo. </p>
                                <p>No representa ningún recibo de pago.</p>
                                <!--
                               <h4 class="text-orange font-weight-bolder mt-2">El importe a pagar ya incluye el 100% de descuento en recargos, gastos de ejecución y cobranza.
                            Marzo – Abril del 2025
</h4>-->
                            </div>

                        </div>
                    </div>
                
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                        <!--
                        <div class="mdb-item" *ngFor="let imagen of imagenes">
                            <div class="view ">
                                <img class="img-fluid" [src]="imagen.ruta" alt="First slide">
                                <div class="mask rgba-black-light waves-light" mdbWavesEffect></div>
                            </div>
                 
                        </div>-->
                        <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div *ngFor="let data of imagenes; let i = index" class="carousel-item" [class.active]="i === 0">
                                    <img src="{{data.ruta}}" class="d-block w-100 rounded" alt="...">
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                </div>

               

              
                
                </div>
            </div>
        </div>
<!--
    <ng-template #template>
        <div class="modal-header">
            <h4 class="modal-title pull-left">Predial</h4>
            
        </div>
        <div class="modal-body">
            <div class="modal-dialog modal-info modal-dialog-centered modal-" role="document">
                <div class="modal-content bg-gradient-info">
                    <div class="modal-header">
                        <div class="col-12">
                            <h6 class="modal-title" id="modal-title-notification">
                                Ingrese Nombre del Propietario
                            </h6>
                            <p class="mt-2">El nombre ingresado debe ser el mismo que se muestra en su recibo.</p>
                        </div>
                
                    </div>
                    <div class="modal-body">
                        <div class="py-3 text-center">
                            <input  [(ngModel)]="forma.nombre" name="nombre" minlength="2" maxlength="300" required
                                class="form-control text-dark" type="text" placeholder="ESCRIBE EL NOMBRE DEL PROPIETARIO">
                        </div>
                        <div class="text-center">
                            <button class="btn btn-primary mb-3" type="button" (click)="validar(template)">
                                EFECTUAR PAGO
                            </button>
                            <div *ngIf="mensaje!=''" class="alert alert-danger alert-dismissible fade show" role="alert">
                                <span class="alert-inner--text">{{mensaje}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                    
                    </div>
                </div>
            </div>
        </div>
       
    </ng-template>-->

        <div aria-hidden="true" aria-labelledby="modal-notification" bsModal class="modal fade" #m="bs-modal"
            id="modal-notification" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-info modal-dialog-centered modal-" role="document">
                <div class="modal-content bg-gradient-info">
                    <div class="modal-header">
                        <div class="col-12">
                            <h6 class="modal-title" id="modal-title-notification">
                               
                                INGRESE NOMBRE DEL PROPIETARIO(MAYUSCULAS)
                            </h6>
                            <p class="mt-2">
                                EL NOMBRE INGRESADO DEBE SER EL MISMO QUE SE MUESTRA EN SU RECIBO
                            </p>
                        </div>
                      
                    </div>
                    <div class="modal-body">
                        <div class="py-3 text-center">
                            <input [(ngModel)]="forma.nombre" name="nombre" minlength="2" maxlength="300" required
                                class="form-control text-dark" type="text"
                                placeholder="ESCRIBE EL NOMBRE DEL PROPIETARIO">
                        </div>
                        <div class="text-center">
                            <button class="btn btn-primary mb-3" type="button" (click)="validar(m)">
                                EFECTUAR PAGO
                            </button>
                            <div *ngIf="mensaje!=''" class="alert alert-danger alert-dismissible fade show"
                                role="alert">
                                <span class="alert-inner--text">{{mensaje}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-link text-white ml-auto" data-dismiss="modal" (click)="m.hide()"
                            type="button">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    

    </div>

